app.mediator.registerModule(MODULE_NAME__GALLERY_FILTERS, function (app) {

    return {

        $rootElem: null,
        currentSearchText: '',

        // The url which will be posted to in order to retrieve more entries in JSON format.
        filterAvailabilityUrl: '/umbraco/api/EntryApi/EntriesInfo',

        selectorClasses: {
            focusedButton: 'focused',
            activeButton: 'active',
            disabledButton: 'disabled'
        },

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            var scope = this;

            this.$rootElem = $('.mod-gallery-filters');
            if (!this.$rootElem.length) return;

            this.addDomListeners();
            this.addMediatorListeners();

            scope.getSelectableAdditionalFilters(function (flatFilters) {
                scope.updateSelectableAdditionalFilters(flatFilters);
            });

            // We must programatically close the panels on init
            // (rather than having "closed panel markup"), as if the panels
            // are closed on page load, the custom scrollbars (nanoscroller) will not render.
            scope.closePanels();

            scope.broadcastFilterData({
                broadcastingDueTo: 'initialLoad'
            });

            app.mediator.notify(EVENT_NAME__GALLERY_FILTERS__INITIATED);
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addDomListeners: function () {

            var scope = this;
            var $formElem = this.getFormElem();

            this.$rootElem.find('.cancel-btn').click(function () {
                scope.hide('cancel');
            });
            this.$rootElem.find('.clear-btn').click(function () {
                scope.resetFilterData();
                scope.broadcastFilterData({
                    broadcastingDueTo: 'filterClear'
                });
            });
            this.$rootElem.find('.apply-btn').click(function () {
                scope.broadcastFilterData();
                scope.hide('apply');
            });
            this.$rootElem.find('input[type=checkbox]').change(function (e) {
                scope.getSelectableAdditionalFilters(function (flatFilters) {
                    scope.updateSelectableAdditionalFilters(flatFilters);
                });
            });
            $formElem.on('submit', function (e) {
                e.preventDefault();
            });
            this.$rootElem.find('input[type=checkbox]').focus(function (e) {
                scope.focusButton($(this).closest('.btn'));
            });
            this.$rootElem.find('input[type=checkbox]').blur(function (e) {
                scope.unfocusButton($(this).closest('.btn'));
            });
            $(document).keyup(function (e) {
                if (e.keyCode == 27) { // esc
                    scope.hide('cancel');
                }
            });
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {

            var scope = this;

            app.mediator.addListener(EVENT_NAME__GALLERY_TITLE_BAR__OPEN_FILTERS_BUTTON_CLICKED, function () {
                scope.getSelectableAdditionalFilters(function (flatFilters) {
                    scope.updateSelectableAdditionalFilters(flatFilters);
                });
                scope.show();
            }, this);

            app.mediator.addListener(EVENT_NAME__GALLERY__FILTER_DATA_RESTORED, function (data) {
                scope.populateUiWithFilterData(data.restoredFilterData);
            });

            app.mediator.addListener(EVENT_NAME__GALLERY_TITLE_BAR__NEW_FILTER_DATA_APPLIED, function (data) {
                scope.currentSearchText = data.filterData.searchTerm;
                scope.getSelectableAdditionalFilters(function (flatFilters) {
                    scope.updateSelectableAdditionalFilters(flatFilters);
                });
            });

            app.mediator.addListener(EVENT_NAME__GALLERY__GALLERY_INITIATED, function() {
                scope.broadcastFilterData({
                    broadcastingDueTo: 'initialLoad'
                });
            });
        },

        //==========================================================xdiv2====
        // Module: General
        //===================================================================

        goToStart: function () {
            this.$rootElem.find('.cancel-btn').focus();
        },

        getFormElem: function () {
            return this.$rootElem.find('form');
        },

        isShowing: function () {
            return this.$rootElem.hasClass('active');
        },

        show: function () {
            if (!this.isShowing()) {
                this.goToStart();
            }
            this.$rootElem.addClass('active');
            $("body").addClass('no-scroll');
            app.mediator.notify(EVENT_NAME__GALLERY_FILTERS__OPENED);
        },

        hide: function (hideIntent) {
            this.$rootElem.removeClass('active');
            $("body").removeClass('no-scroll');
            app.mediator.notify(EVENT_NAME__GALLERY_FILTERS__CLOSED, {
                hideIntent: hideIntent
            });
        },

        openPanels: function () {
            this.$rootElem.find('.panel').each(function (k, panel) {
                var $panel = $(panel);
                $panel.find('.panel-collapse').collapse('show');
                $panel.find('.panel-title a').removeClass('collapsed').attr('aria-expanded', 'true');
            });
        },

        closePanels: function () {
            this.$rootElem.find('.panel').each(function (k, panel) {
                var $panel = $(panel);
                $panel.find('.panel-collapse').collapse('hide');
                $panel.find('.panel-title a').addClass('collapsed').attr('aria-expanded', 'false');
            });
        },

        toggle: function () {
            if (this.isShowing()) {
                this.hide();
            } else {
                this.show();
            }
        },

        //==========================================================xdiv2====
        // Module: Input UI control
        //===================================================================

        resetFilterData: function() {
            this.currentSearchText = '';
            this.resetAllButtons();
        },

        resetAllButtons: function () {
            var scope = this;
            var $btns = this.$rootElem.find('.btn-group .btn');
            $btns.each(function(btnKey, btn) {
                var $btn = $(btn);
                scope.disengageButton($btn);
                scope.reenableButton($btn);
            });
            scope.getSelectableAdditionalFilters(function (flatFilters) {
                scope.updateSelectableAdditionalFilters(flatFilters);
            });
        },

        engageButton: function($btn) {
            $btn.addClass(this.selectorClasses.activeButton).find('input').prop('checked', true);
        },

        disengageButton: function($btn) {
            $btn.removeClass(this.selectorClasses.activeButton).find('input').prop('checked', false);
        },

        focusButton: function($btn) {
            $btn.addClass(this.selectorClasses.focusedButton);
        },

        unfocusButton: function($btn) {
            $btn.removeClass(this.selectorClasses.focusedButton);
        },

        disableButton: function($btn) {
            $btn.addClass(this.selectorClasses.disabledButton).find('input').prop('disabled', true);
        },

        reenableButton: function($btn) {
            $btn.removeClass(this.selectorClasses.disabledButton).find('input').prop('disabled', false);
        },

        //==========================================================xdiv2====
        // Module: Filter data I/O
        //===================================================================

        populateUiWithFilterData: function(filterData) {
            var scope = this;
            function enableGuidButton(guid) {
                $input = scope.getFormElem().find('.panel input[value="' + guid + '"]');
                $btn = $input.closest('.btn');
                if ($btn.length) {
                    scope.engageButton($btn);
                }
            }
            var inputKeys = ['awards', 'categories', 'prizes', 'territories'];
            inputKeys.forEach(function(inputKey) {
                if (typeof filterData[inputKey] === 'object' && filterData[inputKey] instanceof Array) {
                    filterData[inputKey].forEach(function(guid) {
                        enableGuidButton(guid);
                    });
                }
            });
        },

        // Returns a JSON object that represents the state of the filter
        // controls UI element in its entirety
        getFilterData: function () {
            var scope = this;
            var $formElem = this.getFormElem();
            var data = $formElem.serializeObject();
            var flatPrizes = [];
            if (data.prizes != null) {
                data.prizes.forEach(function (item) {
                    flatPrizes.push.apply(flatPrizes, item.split(','));
                });
            }
            return {
                winnersOnly: data.winnersOnly,
                defaultSortOrder: data.defaultSortOrder,
                awards: data.awards,
                prizes: flatPrizes,
                territories: data.territories,
                categories: data.categories,
                pageCultureCode: data.pageCultureCode,
                requestCultureCode: data.requestCultureCode
            };
        },

        // Converts the supplied filter data object into a single dimensional array.
        getFlatFilterData: function (filterData) {
            return [].concat.apply([], [filterData.categories, filterData.territories, filterData.prizes, filterData.awards]);
        },

        // Emits the state of the filter controls UI element to the mediator
        broadcastFilterData: function (options) {
            var options = typeof options !== 'undefined' ? options : {};
            options.broadcastingDueTo = typeof options.broadcastingDueTo !== 'undefined' ? options.broadcastingDueTo : 'generalFilterChange';
            var data = this.getFilterData();
            if (data.awards == null || data.awards == undefined) {
                data.awards = this.defaultAwards();
            }
            app.mediator.notify(EVENT_NAME__GALLERY_FILTERS__NEW_FILTER_DATA_APPLIED, {
                filterData: data,
                filterDataUpdateDueTo: options.broadcastingDueTo
            });
        },

        // gets all available award years
        defaultAwards: function () {
            var awards = [];
            var $checkboxes = $('#accordion-years input:not([disabled])');
            $checkboxes.each(function (k, checkbox) {
                var val = $(checkbox).attr('value');
                awards.push(val);
            });
            return awards;
        },

        // Makes an ajax request to the server to get a flat, one-dimensional array of
        // input values. These values are a list of which checkboxes should be enabled.
        getSelectableAdditionalFilters: function (callback, filterDataIn) {
            var scope = this;
            filterDataIn = typeof filterDataIn !== 'undefined' ? filterDataIn : this.getFilterData();
            filterDataIn.text = scope.currentSearchText;
            if (filterDataIn.awards == null || filterDataIn.awards == undefined) {
                filterDataIn.awards = this.defaultAwards();
            }
            $.ajax({
                type: "POST",
                url: scope.filterAvailabilityUrl,
                data: filterDataIn,
                dataType: "json",
                success: function (response) {
                    var flatFilterDataOut = scope.getFlatFilterData(response.result);
                    if (typeof callback === 'function') callback(flatFilterDataOut);
                },
                error: function (response, status, err) {
                    if (typeof callback === 'function') callback([]);
                }
            });
        },

        // Takes a flat, one-dimensional array of input values, and then iterates through
        // all of the checkbox buttons that are within the gallery filters UI fragment,
        // enabling all, and then disabling all that are not within the flatFilterData array.
        updateSelectableAdditionalFilters: function (flatFilterData) {
            if (!flatFilterData instanceof Array) flatFilterData = [];
            var $btns = this.$rootElem.find('.btn-group .btn');
            $btns.each(function (btnK, btn) {
                var $checkbox = $(btn).find('input[type=checkbox]');
                var val = $checkbox.val();
                if ($.inArray(val, flatFilterData) < 0) {
                    $(btn).addClass('disabled').removeClass('active').find('input').prop('checked', false).prop('disabled', true);
                } else {
                    $(btn).removeClass('disabled').find('input').prop('disabled', false);
                }
            });
        }
    };
});